import type { Column, DynamicGroup } from '../types';

/**
 * 用于「显示列」的 schema 子集（仅含 columns + dynamicGroups）
 */
export interface SchemaForDisplay {
  columns: Column[];
  dynamicGroups?: DynamicGroup[];
}

/**
 * 将 schema 折叠为「显示列」：动态字段不展开为多列，只显示公共名称（一个入口代表整组）。
 * 用于上游节点列选择（筛选、排序、计算、转换、删除列、关联等）。
 */
export function getDisplayColumns(schema: SchemaForDisplay): Column[] {
  if (!schema.columns.length && !(schema.dynamicGroups?.length)) {
    return [];
  }
  const physicalInGroup = new Set<string>(
    schema.dynamicGroups?.flatMap((g) => g.physicalColumns) ?? []
  );
  const regular = schema.columns.filter((c) => !physicalInGroup.has(c.name));
  const fromGroups: Column[] = (schema.dynamicGroups ?? []).map((g, i) => ({
    name: g.commonName,
    type: 'string',
    nullable: true,
    index: regular.length + i,
    dynamicGroup: g.commonName,
  }));
  return [...regular, ...fromGroups];
}
